import * as React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { Box } from '@mui/material';
import FormProvider, { RHFSelect } from 'components/hook-form';
import { useLocales } from 'locales';

const CycleSelect = () => {
    const { t } = useLocales();
    const isInitialRender = React.useRef(true);

    const schema = Yup.object().shape({
        cycle: Yup.string().required(t('Cycle is required')),
    });

    const methods = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            cycle: localStorage.getItem('cycle') || 'monthly',
        },
    });

    const { handleSubmit, watch, setValue } = methods;
    const cycle = watch('cycle');

    React.useEffect(() => {
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        localStorage.setItem('cycle', cycle);
        handleSubmit(async (data) => {
            setValue('cycle', data.cycle);
            window.location.reload();
        })();
    }, [cycle, handleSubmit, setValue]);

    return (
        <FormProvider methods={methods}>
            <Box sx={{ m: 1, minWidth: 120 }}>
                <RHFSelect name="cycle" label={t('Cycle')} size="small">
                    <option value="weekly">{t("Weekly")}</option>
                    <option value="monthly">{t("Monthly")}</option>
                </RHFSelect>
            </Box>
        </FormProvider>
    );
};

export default CycleSelect;
